import { useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { monitorOrderOnBoardguard } from '../../utils/boardguard'

export const BoardguardMonitorModal = ({ open, orderId, onClose }: {
    open: boolean
    orderId: number
    onClose: () => void
}) => {
    const [isSubmitting, setIsSubmitting] = useState(false)

    const onConfirm = async () => {
        setIsSubmitting(true)
        try {
            await monitorOrderOnBoardguard(orderId)
        } finally {
            setIsSubmitting(false)
            onClose()
        }
    }

    return (
        <Dialog open={open} onClose={isSubmitting ? undefined : onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Monitorar no Boardguard?</DialogTitle>
            <DialogContent dividers>
                <Typography gutterBottom>
                    Deseja cadastrar esta emissão também no Boardguard e gerar o bilhete?
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    O Boardguard acompanha a reserva no site da companhia e avisa sobre alterações e cancelamentos.
                    Após a primeira checagem (cerca de 20 segundos) você será notificado e poderá baixar o bilhete em PDF,
                    sem precisar aguardar nesta tela.
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'space-between', px: 2, py: 1.5 }}>
                <Button variant="outlined" onClick={onClose} disabled={isSubmitting}>
                    Agora não
                </Button>
                <Button variant="contained" onClick={onConfirm} disabled={isSubmitting}>
                    {isSubmitting ? 'Cadastrando...' : 'Sim, monitorar'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}
